import { gql } from "@apollo/client";

export const GET_ALL_FACULITIES=gql`
query Faculties {
    faculties {
        id
        serial
        title_ar
        title_en
        status
        required_dep
        study_years_count
        createdAt
        updatedAt
    }
}
`;

export const GET_FACULITY_BY_ID=gql`
query Faculty($id:ID!) {
    faculty(id: $id) {
        id
        serial
        title_ar
        title_en
        status
        required_dep
        study_years_count
        createdAt
        updatedAt
    }
}

`;

export const CREATE_NEW_FACULITY=gql`
mutation CreateFaculty($input:CreateFacultyInput!) {
    createFaculty(input: $input) {
        id
        serial
        title_ar
        title_en
        status
        required_dep
        study_years_count
        createdAt
        updatedAt
    }
}
`;

export const UPDATE_FACULITY_BY_ID=gql`
mutation UpdateFaculty($id:ID!,$input:UpdateFacultyInput!) {
    updateFaculty(id: $id, input: $input) {
        id
        serial
        title_ar
        title_en
        status
        required_dep
        study_years_count
        createdAt
        updatedAt
    }
}

`;

export const FILTERED_PAGED_FACULITIES=gql`
query FilteredPagedFaculties(
    $limit: Int!
    $page: Int!
    $status: Boolean
    $search: String
) {
    filteredPagedFaculties(search: $search, status: $status, page: $page, limit: $limit) {
        total
        faculties {
            id
            title_ar
            title_en
            status
            required_dep
            study_years_count
            createdAt
            updatedAt
        }
    }
}
`;

//////////////Departments اقسام الكلية///////////////

export const GET_ALL_DEPARTMENTS_FOR_FILTER=gql`
query FilteredPagedFacultyDepartments(
    $limit: Int!
    $page: Int!
    $status: Boolean
    $search: String
    $faculty_id: ID
    ) {
    filteredPagedFacultyDepartments(
        search: $search
        faculty_id: $faculty_id
        status: $status
        page: $page
        limit: $limit
    ) {
        total
        facultyDepartments {
            id
            serial
            title_ar
            title_en
            status
            createdAt
            updatedAt
            faculty_id {
                id
                title_ar
                title_en
                status
                required_dep
                study_years_count
                createdAt
                updatedAt
            }
        }
    }
}
`;
export const GET_ALL_DEPARTMENTS=gql`
query FacultyDepartments {
    facultyDepartments {
        id
        serial
        title_ar
        title_en
        status
        createdAt
        updatedAt
        faculty_id {
            id
            title_ar
            title_en
            status
            required_dep
            study_years_count
            createdAt
            updatedAt
        }
    }
}

`;
export const GET_ALL_DEPARTMENTS_IN_FACULTY_BY_ID=gql`
query GetFacultyDepartmentsByFaculty($faculty_id:ID!) {
    getFacultyDepartmentsByFaculty(faculty_id: $faculty_id) {
        id
        serial
        title_ar
        title_en
        status
        createdAt
        updatedAt
    }
}
`;

export const CREATE_FACULITY_DEPARTMENT=gql`
mutation CreateFacultyDepartment($input : CreateFacultyDepartmentInput!) {
    createFacultyDepartment(input: $input) {
        id
        serial
        title_ar
        title_en
        status
        createdAt
        updatedAt
    }
}

`;


export const UPDATE_FACULITY_DEPARTMENT_BY_ID=gql`
mutation UpdateFacultyDepartment($id:ID!,$input:UpdateFacultyDepartmentInput!) {
    updateFacultyDepartment(id: $id, input: $input) {
        id
        serial
        title_ar
        title_en
        status
        createdAt
        updatedAt
    }
}

`;